import { api } from '../../';
import { PrizeDrawsData, PrizeDrawDetail, SpinResponse } from './types';

export const prizeDrawsApi = api.enhanceEndpoints({ addTagTypes: ['PrizeDraws'] }).injectEndpoints({
  endpoints: build => ({
    getPrizeDrawsList: build.query<PrizeDrawsData, any>({
      query: ({ queryString }) => ({
        url: `v1/promotions/admin/raffle-config?${queryString}`,
        method: 'GET',
      }),
    }),
    getPrizeDrawDetail: build.query<PrizeDrawDetail, number>({
      query: (id) => ({
        url: `v1/promotions/admin/raffle-config/${id}/summary`,
        method: 'GET',
      }),
    }),
    createPrizeDraw: build.mutation<any, FormData>({
      query: body => ({
        url: `v1/promotions/admin/raffle-config`,
        method: 'POST',
        body,
      }),
    }),
    spinPrizeDraw: build.mutation<SpinResponse, number>({
      query: (raffleConfigId) => ({
        url: `v1/promotions/admin/major-draw/${raffleConfigId}/spin`,
        method: 'POST',
      }),
    }),
    reviewEntry: build.mutation<any, { entryId: number; status: string; notes: string }>({
      query: ({ entryId, ...body }) => ({
        url: `v1/promotions/admin/major-draw/review/${entryId}`,
        method: 'PATCH',
        body,
      }),
    }),
  }),
});

export const {
  useLazyGetPrizeDrawsListQuery,
  useLazyGetPrizeDrawDetailQuery,
  useCreatePrizeDrawMutation,
  useSpinPrizeDrawMutation,
  useReviewEntryMutation,
} = prizeDrawsApi;
